export default "__VITE_ASSET__12c1e29f__"